<template>
  <div class="content">
    <van-loading type="spinner" v-if="nodata"/>
    <div class="about">
      <span v-if="dominItem.templateId === 'temp3'" style="font-size: 20px; color: #333333">{{ dominItem.logoName || 'Logo' }}</span>
      <div style="margin-right: 30px">
        <span>{{ nowDate }}</span>
        <span @click="changeType(1)" style="margin: 0 20px">{{ $t('con_home') }}</span>
        <span @click="changeType(1)">{{ $t('con_about') }}</span>
      </div>
    </div>
    <div class="logo" :style="{'justify-content': dominItem.templateId === 'temp2' ? 'space-between' : ''}">
      <div class="logo-name" v-if="dominItem.templateId !== 'temp3'"
           :class="[dominItem.templateId ? 'logo-' + dominItem.templateId : '']">
        {{ dominItem.logoName || 'Logo' }}</div>
      <div class="category"
           :class="[dominItem.templateId === 'temp3' ? 'catetemp3'
           : dominItem.templateId === 'temp2' ? 'catetemp2' : '']">
        <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
            item.label
          }}</span>
      </div>
    </div>
    <div style="display: flex">
      <div style="padding-left: 5%;margin-right: 20px; width: 70%">
        <div class="content-hot" v-if="bestInfo">
          <div class="img-Box" @click="toDetail(bestInfo.articleShortName)">
            <img :src="bestInfo.articleImage" alt="">
          </div>

          <div class="hot hot-fifst"><span class="hot-name">{{ $t('con_recommended') }}</span></div>

          <div class="post-list">
            <div v-for="(item, index) in articleList" class="post-list-box">
              <template>
                <div style="display: flex; justify-content: space-between">
                  <span class="title" style="cursor: pointer" @click="toDetail(item.articleShortName)">{{
                      item.articleTitle
                    }}</span>
<!--                  <span>{{ item.uploadTime }}</span>-->
                </div>
                <div class="contentbox">
                  <div class="asimg">
                    <img @click="toDetail(item.articleShortName)" :src="item.articleImage" alt="">
                  </div>
                  <span class="articleIntro-box">{{
                      item.articleIntro
                    }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; flex-direction: column; width: 25%;">
        <div class="last-news">
          <!--          -->
          <div class="hot "><span class="hot-name">{{ $t('con_hot_con') }}</span></div>

          <div class="last-news-content">
            <div v-for="(item,index) in latestNewsList" @click="toDetail(item.articleShortName)">
              <span class="articleIntro" style="margin-top: 10px"><span class="num-box">{{
                  index + 1
                }}</span>{{ item.articleTitle }}</span>
            </div>
          </div>
        </div>

        <div class="last-news cat-news">
          <div class="hot"><span class="hot-name">{{ $t('con_latest') }}</span></div>
          <div v-for="(item, index) in recommendList" @click="toDetail(item.articleShortName)">
            <div>
              <span class="articleIntro" style="margin-top: 10px; font-size: 15px"><span
                  class="icon">></span>{{ item.articleTitle }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <span>© 2023 - {{ dominItem.logoName || 'Logo' }}. All Rights Reserved. Website: {{
          dominItem.logoName || 'Logo'
        }}</span>
    </div>
  </div>
</template>
<script>
import {getContentList, getLatestNews, getRecommend, getOne, getDomainName} from "@/api/index"
import {format} from 'date-fns'
import Clipboard from 'clipboard';
import {Toast} from 'vant';

export default {
  props: {
    dominItem: Object
  },
  data() {
    return {
      current: 1,
      clipboardText: window.location.href,
      currentPage: 1,
      nodata: false,
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7}],
      articleList: [],
      latestNewsList: [],
      recommendList: [],
      newsPageNum: 1,
      newsTotal: undefined,
      recommendPageNum: 1,
      recommendTotal: undefined,
      bestInfo: undefined,
      nowDate: undefined

    };
  },

  created() {
    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    }else {
      this.getArticleList()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getOneList()
    }
    this.nowDate = format(new Date(), this.$t('con_format'))
  },

  methods: {
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getOneList()
    },
    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        this.bestInfo = res.data
        this.bestInfo.uploadTime = format(new Date(res.data.uploadTime), this.$t('con_format'))
        this.bestInfo.articleImage = this.bestInfo.articleImage ? this.bestInfo.articleImage :
            JSON.parse(localStorage.getItem('dominItem')).defaultImg
      })
    },

    // 获取文章列表
    getArticleList() {
      this.nodata = true
      getContentList({articleCategoryId: this.current, articleNationId:  this.dominItem.nationId}).then(res => {
        this.articleList = res.rows
        this.articleList.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          r.articleImage = r.articleImage ? r.articleImage :
              JSON.parse(localStorage.getItem('dominItem')).defaultImg
        })
        this.nodata = false
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList() {
      getLatestNews({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 500000,
        articleNationId: this.dominItem.nationId
      }).then(res => {
        this.latestNewsList = res.rows
        this.newsTotal = res.total
        this.latestNewsList.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        })
      })
    },

    //  获取推荐的文章
    getRecommendList() {
      getRecommend({
        articleCategoryId: this.current,
        pageNum: this.recommendPageNum,
        pageSize: 60000,
        articleNationId: this.dominItem.nationId
      }).then(res => {
        this.recommendList = res.rows
        this.recommendTotal = res.total
        this.recommendList.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        })
      })
    },

    //  查看详情
    toDetail(name) {
      //articleShortName
      this.$router.push(`/details/${name}?type=${this.current}`)
      // this.$router.push(`/details/${name}`)
    }
  },
};
</script>
<style lang="scss" scoped>
@import "cn";
</style>
